module.exports = __webpack_public_path__ + "static/img/img-features-feature-5-i-pad.187f7ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-5-i-pad.png
// module id = F5mm
// module chunks = 18